// @generated by protoc-gen-es v1.10.1 with parameter "target=ts,import_extension=none"
// @generated from file mono/datagateway/v1/seats.proto (package mono.datagateway.v1, syntax proto3)
/* eslint-disable */ // @ts-nocheck
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
import { Message, proto3, protoInt64 } from "@bufbuild/protobuf";
/**
 * @generated from message mono.datagateway.v1.Seat
 */ export class Seat extends Message {
    static fromBinary(bytes, options) {
        return new Seat().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new Seat().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new Seat().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(Seat, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string name = 2;
   */ _define_property(this, "name", ""), /**
   * @generated from field: string description = 3;
   */ _define_property(this, "description", ""), /**
   * @generated from field: string customer_org_id = 4;
   */ _define_property(this, "customerOrgId", ""), /**
   * @generated from field: string customer_label = 5;
   */ _define_property(this, "customerLabel", ""), /**
   * @generated from field: string vehicle_id = 6;
   */ _define_property(this, "vehicleId", ""), /**
   * @generated from field: string vehicle_label = 7;
   */ _define_property(this, "vehicleLabel", ""), /**
   * @generated from field: string split_from_seat_id = 8;
   */ _define_property(this, "splitFromSeatId", ""), /**
   * @generated from field: string split_on = 9;
   */ _define_property(this, "splitOn", ""), /**
   * @generated from field: string merged_into_seat_id = 10;
   */ _define_property(this, "mergedIntoSeatId", ""), /**
   * @generated from field: string merged_on = 11;
   */ _define_property(this, "mergedOn", ""), /**
   * within a landscape
   *
   * @generated from field: int32 sort_order = 12;
   */ _define_property(this, "sortOrder", 0), /**
   * ordered by round_index
   *
   * @generated from field: repeated mono.datagateway.v1.SeatRound rounds = 13;
   */ _define_property(this, "rounds", []), /**
   * derived
   *
   * @generated from field: repeated mono.datagateway.v1.SeatPursuit pursuits = 14;
   */ _define_property(this, "pursuits", []), /**
   * derived
   *
   * @generated from field: repeated mono.datagateway.v1.SeatEvent events = 15;
   */ _define_property(this, "events", []), /**
   * @generated from field: string archived_at = 16;
   */ _define_property(this, "archivedAt", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(Seat, "runtime", proto3);
_define_property(Seat, "typeName", "mono.datagateway.v1.Seat");
_define_property(Seat, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "description",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "customer_org_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "customer_label",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "vehicle_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "vehicle_label",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "split_from_seat_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 9,
            name: "split_on",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 10,
            name: "merged_into_seat_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 11,
            name: "merged_on",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 12,
            name: "sort_order",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 13,
            name: "rounds",
            kind: "message",
            T: SeatRound,
            repeated: true
        },
        {
            no: 14,
            name: "pursuits",
            kind: "message",
            T: SeatPursuit,
            repeated: true
        },
        {
            no: 15,
            name: "events",
            kind: "message",
            T: SeatEvent,
            repeated: true
        },
        {
            no: 16,
            name: "archived_at",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.SeatRound
 */ export class SeatRound extends Message {
    static fromBinary(bytes, options) {
        return new SeatRound().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new SeatRound().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new SeatRound().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(SeatRound, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: int32 round_index = 2;
   */ _define_property(this, "roundIndex", 0), /**
   * prior | current | future
   *
   * @generated from field: string status = 3;
   */ _define_property(this, "status", ""), /**
   * @generated from field: string holder_kind = 4;
   */ _define_property(this, "holderKind", ""), /**
   * @generated from field: string holder_company_id = 5;
   */ _define_property(this, "holderCompanyId", ""), /**
   * @generated from field: string holder_label = 6;
   */ _define_property(this, "holderLabel", ""), /**
   * @generated from field: string program_id = 7;
   */ _define_property(this, "programId", ""), /**
   * @generated from field: string registry_contract_id = 8;
   */ _define_property(this, "registryContractId", ""), /**
   * @generated from field: string opportunity_id = 9;
   */ _define_property(this, "opportunityId", ""), /**
   * @generated from field: string label = 10;
   */ _define_property(this, "label", ""), /**
   * @generated from field: string pop_start = 11;
   */ _define_property(this, "popStart", ""), /**
   * @generated from field: string pop_end = 12;
   */ _define_property(this, "popEnd", ""), /**
   * @generated from field: string options_end = 13;
   */ _define_property(this, "optionsEnd", ""), /**
   * @generated from field: int64 value_cents = 14;
   */ _define_property(this, "valueCents", protoInt64.zero), /**
   * @generated from field: int64 mods_value_cents = 15;
   */ _define_property(this, "modsValueCents", protoInt64.zero), /**
   * from the round's opportunity (GRW-06), future rounds only
   *
   * @generated from field: string rfp_expected_on = 16;
   */ _define_property(this, "rfpExpectedOn", ""), /**
   * @generated from field: string rfp_expected_basis = 17;
   */ _define_property(this, "rfpExpectedBasis", ""), /**
   * @generated from field: string source_basis = 18;
   */ _define_property(this, "sourceBasis", ""), /**
   * @generated from field: string source_note = 19;
   */ _define_property(this, "sourceNote", ""), /**
   * @generated from field: string scope_object_type = 20;
   */ _define_property(this, "scopeObjectType", ""), /**
   * authz target for morgans (programs: delivery.programs/<program id>)
   *
   * @generated from field: string scope_object_id = 21;
   */ _define_property(this, "scopeObjectId", ""), /**
   * @generated from field: string vehicle_id = 22;
   */ _define_property(this, "vehicleId", ""), /**
   * effective vehicle of this round (see ListSeatsRequest)
   *
   * @generated from field: string vehicle_label = 23;
   */ _define_property(this, "vehicleLabel", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(SeatRound, "runtime", proto3);
_define_property(SeatRound, "typeName", "mono.datagateway.v1.SeatRound");
_define_property(SeatRound, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "round_index",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 3,
            name: "status",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "holder_kind",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "holder_company_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "holder_label",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "program_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "registry_contract_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 9,
            name: "opportunity_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 10,
            name: "label",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 11,
            name: "pop_start",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 12,
            name: "pop_end",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 13,
            name: "options_end",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 14,
            name: "value_cents",
            kind: "scalar",
            T: 3 /* ScalarType.INT64 */ 
        },
        {
            no: 15,
            name: "mods_value_cents",
            kind: "scalar",
            T: 3 /* ScalarType.INT64 */ 
        },
        {
            no: 16,
            name: "rfp_expected_on",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 17,
            name: "rfp_expected_basis",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 18,
            name: "source_basis",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 19,
            name: "source_note",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 20,
            name: "scope_object_type",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 21,
            name: "scope_object_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 22,
            name: "vehicle_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 23,
            name: "vehicle_label",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * derived: pursuit on a round via opportunity_id or recompete program
 *
 * @generated from message mono.datagateway.v1.SeatPursuit
 */ export class SeatPursuit extends Message {
    static fromBinary(bytes, options) {
        return new SeatPursuit().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new SeatPursuit().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new SeatPursuit().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(SeatPursuit, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string capture_project_id = 1;
   */ _define_property(this, "captureProjectId", ""), /**
   * @generated from field: string zou_project_id = 2;
   */ _define_property(this, "zouProjectId", ""), /**
   * @generated from field: string name = 3;
   */ _define_property(this, "name", ""), /**
   * @generated from field: string lifecycle = 4;
   */ _define_property(this, "lifecycle", ""), /**
   * @generated from field: string round_id = 5;
   */ _define_property(this, "roundId", ""), /**
   * opportunity | recompete
   *
   * @generated from field: string relation = 6;
   */ _define_property(this, "relation", ""), /**
   * capture_projects.created_at
   *
   * @generated from field: string started_at = 7;
   */ _define_property(this, "startedAt", ""), /**
   * close/outcome event date, or "" when open
   *
   * @generated from field: string ended_at = 8;
   */ _define_property(this, "endedAt", ""), /**
   * won | lost | no_bid | open
   *
   * @generated from field: string outcome = 9;
   */ _define_property(this, "outcome", ""), /**
   * @generated from field: string split_from_capture_project_id = 10;
   */ _define_property(this, "splitFromCaptureProjectId", ""), /**
   * label keys (§3.1)
   *
   * @generated from field: repeated string labels = 11;
   */ _define_property(this, "labels", []), /**
   * explicit pursuit opt-in; default hidden
   *
   * @generated from field: bool show_growth_hint_to_delivery = 12;
   */ _define_property(this, "showGrowthHintToDelivery", false);
        proto3.util.initPartial(data, this);
    }
}
_define_property(SeatPursuit, "runtime", proto3);
_define_property(SeatPursuit, "typeName", "mono.datagateway.v1.SeatPursuit");
_define_property(SeatPursuit, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "capture_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "zou_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "lifecycle",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "round_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "relation",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "started_at",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "ended_at",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 9,
            name: "outcome",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 10,
            name: "split_from_capture_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 11,
            name: "labels",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        },
        {
            no: 12,
            name: "show_growth_hint_to_delivery",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.SeatEvent
 */ export class SeatEvent extends Message {
    static fromBinary(bytes, options) {
        return new SeatEvent().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new SeatEvent().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new SeatEvent().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(SeatEvent, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string seat_id = 2;
   */ _define_property(this, "seatId", ""), /**
   * market | work | decision | delivery | theirs | loss | people | lesson
   *
   * @generated from field: string kind = 3;
   */ _define_property(this, "kind", ""), /**
   * @generated from field: string occurred_at = 4;
   */ _define_property(this, "occurredAt", ""), /**
   * @generated from field: string title = 5;
   */ _define_property(this, "title", ""), /**
   * @generated from field: string description = 6;
   */ _define_property(this, "description", ""), /**
   * @generated from field: string source_label = 7;
   */ _define_property(this, "sourceLabel", ""), /**
   * @generated from field: string entity_kind = 8;
   */ _define_property(this, "entityKind", ""), /**
   * for the "Open …" link
   *
   * @generated from field: string entity_id = 9;
   */ _define_property(this, "entityId", ""), /**
   * @generated from field: string scope_object_type = 10;
   */ _define_property(this, "scopeObjectType", ""), /**
   * @generated from field: string scope_object_id = 11;
   */ _define_property(this, "scopeObjectId", ""), /**
   * capture_project | rfi_response | project | program | opportunity
   *
   * @generated from field: string policy_kind = 12;
   */ _define_property(this, "policyKind", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(SeatEvent, "runtime", proto3);
_define_property(SeatEvent, "typeName", "mono.datagateway.v1.SeatEvent");
_define_property(SeatEvent, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "seat_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "kind",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "occurred_at",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "title",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "description",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "source_label",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "entity_kind",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 9,
            name: "entity_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 10,
            name: "scope_object_type",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 11,
            name: "scope_object_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 12,
            name: "policy_kind",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.MarketDensityPoint
 */ export class MarketDensityPoint extends Message {
    static fromBinary(bytes, options) {
        return new MarketDensityPoint().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new MarketDensityPoint().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new MarketDensityPoint().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(MarketDensityPoint, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string month = 1;
   */ _define_property(this, "month", ""), /**
   * @generated from field: int32 count = 2;
   */ _define_property(this, "count", 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(MarketDensityPoint, "runtime", proto3);
_define_property(MarketDensityPoint, "typeName", "mono.datagateway.v1.MarketDensityPoint");
_define_property(MarketDensityPoint, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "month",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "count",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.GetLandscapeSeatsRequest
 */ export class GetLandscapeSeatsRequest extends Message {
    static fromBinary(bytes, options) {
        return new GetLandscapeSeatsRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetLandscapeSeatsRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetLandscapeSeatsRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetLandscapeSeatsRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string tenant_id = 1;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string landscape_id = 2;
   */ _define_property(this, "landscapeId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetLandscapeSeatsRequest, "runtime", proto3);
_define_property(GetLandscapeSeatsRequest, "typeName", "mono.datagateway.v1.GetLandscapeSeatsRequest");
_define_property(GetLandscapeSeatsRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "landscape_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.GetLandscapeSeatsResponse
 */ export class GetLandscapeSeatsResponse extends Message {
    static fromBinary(bytes, options) {
        return new GetLandscapeSeatsResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetLandscapeSeatsResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetLandscapeSeatsResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetLandscapeSeatsResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.datagateway.v1.Seat seats = 1;
   */ _define_property(this, "seats", []), /**
   * opportunity_activities of member opportunities, by month
   *
   * @generated from field: repeated mono.datagateway.v1.MarketDensityPoint market = 2;
   */ _define_property(this, "market", []), /**
   * @generated from field: int32 market_total = 3;
   */ _define_property(this, "marketTotal", 0), /**
   * landscape-level people band (v1: empty unless REG people movement exists)
   *
   * @generated from field: repeated mono.datagateway.v1.SeatEvent people = 4;
   */ _define_property(this, "people", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetLandscapeSeatsResponse, "runtime", proto3);
_define_property(GetLandscapeSeatsResponse, "typeName", "mono.datagateway.v1.GetLandscapeSeatsResponse");
_define_property(GetLandscapeSeatsResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "seats",
            kind: "message",
            T: Seat,
            repeated: true
        },
        {
            no: 2,
            name: "market",
            kind: "message",
            T: MarketDensityPoint,
            repeated: true
        },
        {
            no: 3,
            name: "market_total",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 4,
            name: "people",
            kind: "message",
            T: SeatEvent,
            repeated: true
        }
    ]));
/**
 * vehicle_id filters ROUNDS, not seats (V5 REG-22): a seat is returned when ≥1 live round has
 * effective vehicle = vehicle_id, where effective vehicle = COALESCE(round.vehicle_id,
 * registry_contracts.vehicle_id of round.registry_contract_id, seat.vehicle_id); only those rounds
 * are returned in Seat.rounds. Seats with merged_into_seat_id set are excluded (their rounds are
 * listed under the survivor). REG-22 calls this through GRW-24's gated morgans RPC, never directly.
 *
 * @generated from message mono.datagateway.v1.ListSeatsRequest
 */ export class ListSeatsRequest extends Message {
    static fromBinary(bytes, options) {
        return new ListSeatsRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListSeatsRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListSeatsRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListSeatsRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string tenant_id = 1;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string vehicle_id = 2;
   */ _define_property(this, "vehicleId", ""), /**
   * @generated from field: string customer_org_id = 3;
   */ _define_property(this, "customerOrgId", ""), /**
   * @generated from field: string landscape_id = 4;
   */ _define_property(this, "landscapeId", ""), /**
   * @generated from field: string search = 5;
   */ _define_property(this, "search", ""), /**
   * @generated from field: bool include_archived = 6;
   */ _define_property(this, "includeArchived", false), /**
   * populate pursuits on the returned rounds; events stay empty
   *
   * @generated from field: bool include_pursuits = 7;
   */ _define_property(this, "includePursuits", false);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListSeatsRequest, "runtime", proto3);
_define_property(ListSeatsRequest, "typeName", "mono.datagateway.v1.ListSeatsRequest");
_define_property(ListSeatsRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "vehicle_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "customer_org_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "landscape_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "search",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "include_archived",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 7,
            name: "include_pursuits",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ListSeatsResponse
 */ export class ListSeatsResponse extends Message {
    static fromBinary(bytes, options) {
        return new ListSeatsResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListSeatsResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListSeatsResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListSeatsResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.datagateway.v1.Seat seats = 1;
   */ _define_property(this, "seats", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListSeatsResponse, "runtime", proto3);
_define_property(ListSeatsResponse, "typeName", "mono.datagateway.v1.ListSeatsResponse");
_define_property(ListSeatsResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "seats",
            kind: "message",
            T: Seat,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.UpsertSeatRequest
 */ export class UpsertSeatRequest extends Message {
    static fromBinary(bytes, options) {
        return new UpsertSeatRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UpsertSeatRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UpsertSeatRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UpsertSeatRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string tenant_id = 1;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: mono.datagateway.v1.Seat seat = 2;
   */ _define_property(this, "seat", void 0), /**
   * @generated from field: string actor = 3;
   */ _define_property(this, "actor", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(UpsertSeatRequest, "runtime", proto3);
_define_property(UpsertSeatRequest, "typeName", "mono.datagateway.v1.UpsertSeatRequest");
_define_property(UpsertSeatRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "seat",
            kind: "message",
            T: Seat
        },
        {
            no: 3,
            name: "actor",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.UpsertSeatResponse
 */ export class UpsertSeatResponse extends Message {
    static fromBinary(bytes, options) {
        return new UpsertSeatResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UpsertSeatResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UpsertSeatResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UpsertSeatResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.Seat seat = 1;
   */ _define_property(this, "seat", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(UpsertSeatResponse, "runtime", proto3);
_define_property(UpsertSeatResponse, "typeName", "mono.datagateway.v1.UpsertSeatResponse");
_define_property(UpsertSeatResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "seat",
            kind: "message",
            T: Seat
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.UpsertSeatRoundRequest
 */ export class UpsertSeatRoundRequest extends Message {
    static fromBinary(bytes, options) {
        return new UpsertSeatRoundRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UpsertSeatRoundRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UpsertSeatRoundRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UpsertSeatRoundRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string tenant_id = 1;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string seat_id = 2;
   */ _define_property(this, "seatId", ""), /**
   * @generated from field: mono.datagateway.v1.SeatRound round = 3;
   */ _define_property(this, "round", void 0), /**
   * @generated from field: string actor = 4;
   */ _define_property(this, "actor", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(UpsertSeatRoundRequest, "runtime", proto3);
_define_property(UpsertSeatRoundRequest, "typeName", "mono.datagateway.v1.UpsertSeatRoundRequest");
_define_property(UpsertSeatRoundRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "seat_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "round",
            kind: "message",
            T: SeatRound
        },
        {
            no: 4,
            name: "actor",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.UpsertSeatRoundResponse
 */ export class UpsertSeatRoundResponse extends Message {
    static fromBinary(bytes, options) {
        return new UpsertSeatRoundResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UpsertSeatRoundResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UpsertSeatRoundResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UpsertSeatRoundResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.SeatRound round = 1;
   */ _define_property(this, "round", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(UpsertSeatRoundResponse, "runtime", proto3);
_define_property(UpsertSeatRoundResponse, "typeName", "mono.datagateway.v1.UpsertSeatRoundResponse");
_define_property(UpsertSeatRoundResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "round",
            kind: "message",
            T: SeatRound
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ArchiveSeatRoundRequest
 */ export class ArchiveSeatRoundRequest extends Message {
    static fromBinary(bytes, options) {
        return new ArchiveSeatRoundRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ArchiveSeatRoundRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ArchiveSeatRoundRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ArchiveSeatRoundRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string tenant_id = 1;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string round_id = 2;
   */ _define_property(this, "roundId", ""), /**
   * @generated from field: string actor = 3;
   */ _define_property(this, "actor", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ArchiveSeatRoundRequest, "runtime", proto3);
_define_property(ArchiveSeatRoundRequest, "typeName", "mono.datagateway.v1.ArchiveSeatRoundRequest");
_define_property(ArchiveSeatRoundRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "round_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "actor",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ArchiveSeatRoundResponse
 */ export class ArchiveSeatRoundResponse extends Message {
    static fromBinary(bytes, options) {
        return new ArchiveSeatRoundResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ArchiveSeatRoundResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ArchiveSeatRoundResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ArchiveSeatRoundResponse, a, b);
    }
    constructor(data){
        super();
        proto3.util.initPartial(data, this);
    }
}
_define_property(ArchiveSeatRoundResponse, "runtime", proto3);
_define_property(ArchiveSeatRoundResponse, "typeName", "mono.datagateway.v1.ArchiveSeatRoundResponse");
_define_property(ArchiveSeatRoundResponse, "fields", proto3.util.newFieldList(()=>[]));
/**
 * @generated from message mono.datagateway.v1.SetLandscapeSeatRequest
 */ export class SetLandscapeSeatRequest extends Message {
    static fromBinary(bytes, options) {
        return new SetLandscapeSeatRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new SetLandscapeSeatRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new SetLandscapeSeatRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(SetLandscapeSeatRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string tenant_id = 1;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string landscape_id = 2;
   */ _define_property(this, "landscapeId", ""), /**
   * @generated from field: string seat_id = 3;
   */ _define_property(this, "seatId", ""), /**
   * @generated from field: bool member = 4;
   */ _define_property(this, "member", false), /**
   * @generated from field: int32 sort_order = 5;
   */ _define_property(this, "sortOrder", 0), /**
   * @generated from field: string actor = 6;
   */ _define_property(this, "actor", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(SetLandscapeSeatRequest, "runtime", proto3);
_define_property(SetLandscapeSeatRequest, "typeName", "mono.datagateway.v1.SetLandscapeSeatRequest");
_define_property(SetLandscapeSeatRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "landscape_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "seat_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "member",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 5,
            name: "sort_order",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 6,
            name: "actor",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.SetLandscapeSeatResponse
 */ export class SetLandscapeSeatResponse extends Message {
    static fromBinary(bytes, options) {
        return new SetLandscapeSeatResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new SetLandscapeSeatResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new SetLandscapeSeatResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(SetLandscapeSeatResponse, a, b);
    }
    constructor(data){
        super();
        proto3.util.initPartial(data, this);
    }
}
_define_property(SetLandscapeSeatResponse, "runtime", proto3);
_define_property(SetLandscapeSeatResponse, "typeName", "mono.datagateway.v1.SetLandscapeSeatResponse");
_define_property(SetLandscapeSeatResponse, "fields", proto3.util.newFieldList(()=>[]));
/**
 * @generated from message mono.datagateway.v1.SplitSeatRequest
 */ export class SplitSeatRequest extends Message {
    static fromBinary(bytes, options) {
        return new SplitSeatRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new SplitSeatRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new SplitSeatRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(SplitSeatRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string tenant_id = 1;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string seat_id = 2;
   */ _define_property(this, "seatId", ""), /**
   * @generated from field: string new_name = 3;
   */ _define_property(this, "newName", ""), /**
   * @generated from field: string split_on = 4;
   */ _define_property(this, "splitOn", ""), /**
   * @generated from field: string actor = 5;
   */ _define_property(this, "actor", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(SplitSeatRequest, "runtime", proto3);
_define_property(SplitSeatRequest, "typeName", "mono.datagateway.v1.SplitSeatRequest");
_define_property(SplitSeatRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "seat_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "new_name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "split_on",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "actor",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.SplitSeatResponse
 */ export class SplitSeatResponse extends Message {
    static fromBinary(bytes, options) {
        return new SplitSeatResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new SplitSeatResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new SplitSeatResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(SplitSeatResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.Seat seat = 1;
   */ _define_property(this, "seat", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(SplitSeatResponse, "runtime", proto3);
_define_property(SplitSeatResponse, "typeName", "mono.datagateway.v1.SplitSeatResponse");
_define_property(SplitSeatResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "seat",
            kind: "message",
            T: Seat
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.MergeSeatsRequest
 */ export class MergeSeatsRequest extends Message {
    static fromBinary(bytes, options) {
        return new MergeSeatsRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new MergeSeatsRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new MergeSeatsRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(MergeSeatsRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string tenant_id = 1;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string loser_seat_id = 2;
   */ _define_property(this, "loserSeatId", ""), /**
   * @generated from field: string survivor_seat_id = 3;
   */ _define_property(this, "survivorSeatId", ""), /**
   * @generated from field: string merged_on = 4;
   */ _define_property(this, "mergedOn", ""), /**
   * @generated from field: string actor = 5;
   */ _define_property(this, "actor", ""), /**
   * Optional membership update, committed atomically with the merge.
   *
   * @generated from field: string landscape_id = 6;
   */ _define_property(this, "landscapeId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(MergeSeatsRequest, "runtime", proto3);
_define_property(MergeSeatsRequest, "typeName", "mono.datagateway.v1.MergeSeatsRequest");
_define_property(MergeSeatsRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "loser_seat_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "survivor_seat_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "merged_on",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "actor",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "landscape_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.MergeSeatsResponse
 */ export class MergeSeatsResponse extends Message {
    static fromBinary(bytes, options) {
        return new MergeSeatsResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new MergeSeatsResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new MergeSeatsResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(MergeSeatsResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.Seat survivor = 1;
   */ _define_property(this, "survivor", void 0), /**
   * @generated from field: bool survivor_added_to_landscape = 2;
   */ _define_property(this, "survivorAddedToLandscape", false);
        proto3.util.initPartial(data, this);
    }
}
_define_property(MergeSeatsResponse, "runtime", proto3);
_define_property(MergeSeatsResponse, "typeName", "mono.datagateway.v1.MergeSeatsResponse");
_define_property(MergeSeatsResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "survivor",
            kind: "message",
            T: Seat
        },
        {
            no: 2,
            name: "survivor_added_to_landscape",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.UnmergeSeatRequest
 */ export class UnmergeSeatRequest extends Message {
    static fromBinary(bytes, options) {
        return new UnmergeSeatRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UnmergeSeatRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UnmergeSeatRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UnmergeSeatRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string tenant_id = 1;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string seat_id = 2;
   */ _define_property(this, "seatId", ""), /**
   * @generated from field: string actor = 3;
   */ _define_property(this, "actor", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(UnmergeSeatRequest, "runtime", proto3);
_define_property(UnmergeSeatRequest, "typeName", "mono.datagateway.v1.UnmergeSeatRequest");
_define_property(UnmergeSeatRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "seat_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "actor",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.UnmergeSeatResponse
 */ export class UnmergeSeatResponse extends Message {
    static fromBinary(bytes, options) {
        return new UnmergeSeatResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UnmergeSeatResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UnmergeSeatResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UnmergeSeatResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.Seat seat = 1;
   */ _define_property(this, "seat", void 0), /**
   * Prior state captured under the same row lock as the undo, for ops audit.
   *
   * @generated from field: string previous_merged_into_seat_id = 2;
   */ _define_property(this, "previousMergedIntoSeatId", ""), /**
   * @generated from field: string previous_merged_on = 3;
   */ _define_property(this, "previousMergedOn", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(UnmergeSeatResponse, "runtime", proto3);
_define_property(UnmergeSeatResponse, "typeName", "mono.datagateway.v1.UnmergeSeatResponse");
_define_property(UnmergeSeatResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "seat",
            kind: "message",
            T: Seat
        },
        {
            no: 2,
            name: "previous_merged_into_seat_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "previous_merged_on",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.SuggestSeatRoundsRequest
 */ export class SuggestSeatRoundsRequest extends Message {
    static fromBinary(bytes, options) {
        return new SuggestSeatRoundsRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new SuggestSeatRoundsRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new SuggestSeatRoundsRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(SuggestSeatRoundsRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string tenant_id = 1;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string seat_id = 2;
   */ _define_property(this, "seatId", ""), /**
   * @generated from field: string landscape_id = 3;
   */ _define_property(this, "landscapeId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(SuggestSeatRoundsRequest, "runtime", proto3);
_define_property(SuggestSeatRoundsRequest, "typeName", "mono.datagateway.v1.SuggestSeatRoundsRequest");
_define_property(SuggestSeatRoundsRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "seat_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "landscape_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.SuggestedRound
 */ export class SuggestedRound extends Message {
    static fromBinary(bytes, options) {
        return new SuggestedRound().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new SuggestedRound().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new SuggestedRound().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(SuggestedRound, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.SeatRound round = 1;
   */ _define_property(this, "round", void 0), /**
   * @generated from field: string reason = 2;
   */ _define_property(this, "reason", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(SuggestedRound, "runtime", proto3);
_define_property(SuggestedRound, "typeName", "mono.datagateway.v1.SuggestedRound");
_define_property(SuggestedRound, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "round",
            kind: "message",
            T: SeatRound
        },
        {
            no: 2,
            name: "reason",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.SuggestSeatRoundsResponse
 */ export class SuggestSeatRoundsResponse extends Message {
    static fromBinary(bytes, options) {
        return new SuggestSeatRoundsResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new SuggestSeatRoundsResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new SuggestSeatRoundsResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(SuggestSeatRoundsResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.datagateway.v1.SuggestedRound suggestions = 1;
   */ _define_property(this, "suggestions", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(SuggestSeatRoundsResponse, "runtime", proto3);
_define_property(SuggestSeatRoundsResponse, "typeName", "mono.datagateway.v1.SuggestSeatRoundsResponse");
_define_property(SuggestSeatRoundsResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "suggestions",
            kind: "message",
            T: SuggestedRound,
            repeated: true
        }
    ]));
